<template>
  <div>
    <div class="display-flex w-100 justify-content-between">
      <h2 class="mb-0">Vouchery</h2>
      <VoucherChips :searched="Object.assign({}, searched)"
                    @updateData="changeSearchData"
                    @toggleSearch="setToggle">
      </VoucherChips>
    </div>
    <transition name="fade" mode="out-in">
      <div class="display-flex w-100 justify-content-end search-form" v-if="searchVouchers">
        <VoucherSearch :typeList="getVouchersTypeList"
                       :propsSearchData="searchData"
                       :userList="getUsersList"
                       @search="search"></VoucherSearch>
      </div>
    </transition>
    <div class="mt-4 content-wrapper p-3">
      <VoucherTable :loading="loading"
                    :totalItems="getTotalVouchers"
                    :currentPage="tablePage"
                    @paginationChange="onPaginationChange"
                    @printPDF="printPDF"
                    @exportPDF="exportPDF"
                    @deleteVoucher="prepareToOpenModal"
                    @finishVoucher="prepareToOpenModal"
                    @addToNote="openAddToNote"/>
    </div>
    <div class="display-flex justify-content-end mt-2">
      <v-btn class="mr-0"
             :loading="exportLoading"
             @click="exportExcel">
        Eksportuj
      </v-btn>
    </div>
    <DeleteModal
      :open="deleteVoucher"
      deleteText="Czy na pewno chcesz usunąć voucher?"
      @close="deleteVoucher = false"
      @accept="removeVoucher({id:voucherIdToEdit, searchObj}); deleteVoucher = false"
    ></DeleteModal>
    <DeleteModal
      :open="deactivateVoucher"
      :show-textarea="showTextarea"
      deleteText="Czy na pewno chcesz zakończyć voucher?"
      @close="deactivateVoucher = false"
      @accept="disableVoucher"
    ></DeleteModal>
    <AddVoucherToNote
      :open="addToNoteOpen"
      :voucherId="voucherToAttachId"
      :voucherNumber="voucherToAttachNumber"
      @close="addToNoteOpen = false"
      @attached="onVoucherAttached"
    ></AddVoucherToNote>
    <router-view></router-view>
  </div>
</template>

<script>
  /* eslint-disable no-unused-expressions */

  import {mapGetters, mapActions} from 'vuex';
  import FileSaver from 'file-saver';
  import printJS from 'print-js';
  import DeleteModal from '../components/Globals/ModalDelete.vue';
  import VoucherChips from '@/components/Vouchers/VoucherChips.vue';
  import VoucherSearch from '@/components/Vouchers/VouchersSearch.vue';
  import VoucherTable from '@/components/Vouchers/VoucherTable.vue';
  import AddVoucherToNote from '@/components/Vouchers/AddVoucherToNote.vue';
  import {clearEmptyFields} from '../helpers/clearEmptyFields';
  import {getPDF} from '../services/api.service';

  export default {
    name: 'Vouchers',
    components: {
      DeleteModal,
      VoucherChips,
      VoucherSearch,
      VoucherTable,
      AddVoucherToNote,
    },
    data() {
      return {
        showTextarea: false,
        searchObj: {},
        searchVouchers: false,
        deleteText: null,
        voucherIdToEdit: null,
        loading: true,
        exportLoading: false,
        tablePage: 1,
        lastPagination: null,
        finishVoucherDate: new Date().toISOString()
          .substr(0, 10),
        finishVoucherDatePicker: false,
        deleteVoucher: false,
        deactivateVoucher: false,
        searchData: {},
        searched: {},
        addToNoteOpen: false,
        voucherToAttachId: null,
        voucherToAttachNumber: '',
      };
    },
    computed: {
      ...mapGetters('VoucherTypeStore', ['getVouchersTypeList']),
      ...mapGetters('UserStore', ['getUsersList']),
      ...mapGetters('VoucherStore', ['getTotalVouchers']),
    },
    watch: {
      $route(from) {
        from.name === 'Vouchers' ? this.fetchVouchers(this.buildFetchParams(this.searchObj, this.lastPagination)) : null;
      },
    },
    beforeMount() {
      this.fetchVouchers(this.buildFetchParams({}, null))
        .then(() => {
          this.loading = false;
        });
      this.fetchVoucherTypes();
      if (JSON.parse(localStorage.getItem('USERDATA')).type !== 'U') {
        this.fetchUsers();
      }
    },
    methods: {
      ...mapActions('VoucherStore', ['fetchVouchers', 'removeVoucher', 'turnOffVoucher', 'getPDF', 'downloadPDF', 'fetchVouchersExcel']),
      ...mapActions('VoucherTypeStore', ['fetchVoucherTypes']),
      ...mapActions('UserStore', ['fetchUsers']),
      async printPDF(id) {
        const response = await getPDF(`/pdf/${id}`);
        const blob = new Blob([response.data], {
          type: 'application/pdf',
        });
        printJS(URL.createObjectURL(blob));
      },
      openAddToNote(voucherId, voucherNumber) {
        this.voucherToAttachId = voucherId;
        this.voucherToAttachNumber = voucherNumber || '';
        this.addToNoteOpen = true;
      },
      onVoucherAttached() {
        this.addToNoteOpen = false;
        this.fetchVouchers(this.buildFetchParams(this.searchObj, this.lastPagination));
      },
      prepareToOpenModal(id, key, showTextarea) {
        this[key] = true;
        this.voucherIdToEdit = id;
        this.showTextarea = showTextarea;
      },
      setToggle(toggle) {
        this.searchVouchers = toggle;
      },
      async exportPDF(id, number, type) {
        const response = await getPDF(`/voucher/realization/pdf/${id}`);
        const blob = new Blob([response.data], {
          type: 'application/pdf',
        });
        FileSaver.saveAs(blob, `${number} - ${type} - ${this.moment(new Date())
          .format('DD-MM-YYYY')} - export`);
      },
      // async generateDebitNote(id) {
      //   const response = await getExcel(`/debit_note/${id}`);
      //   const blob = new Blob([response.data], {
      //     type: 'application/vnd.ms-excel',
      //   });
      //   FileSaver.saveAs(blob, `Debit Note - ${this.moment(new Date())
      //     .format('DD-MM-YYYY')} - export`);
      // },
      async exportExcel() {
        this.exportLoading = true;
        try {
          const response = await this.fetchVouchersExcel(this.searchObj);
          const blob = new Blob([response.data], {
            type: 'application/vnd.ms-excel',
          });
          FileSaver.saveAs(blob, `VouchersExport - ${this.moment(new Date())
            .format('DD-MM-YYYY')} - export`);
        } catch (e) {
          console.log(e);
        } finally {
          this.exportLoading = false;
        }
      },
      buildFetchParams(searchObj, pagination) {
        const params = Object.assign({}, searchObj);
        params.page = (pagination && pagination.page) || 1;
        params.per_page = (pagination && pagination.rowsPerPage) || 10;
        if (pagination && pagination.sortBy) {
          params.sort_by = pagination.sortBy;
          params.sort_dir = pagination.descending ? 'desc' : 'asc';
        }
        return params;
      },
      onPaginationChange(pagination) {
        this.lastPagination = pagination;
        this.fetchVouchers(this.buildFetchParams(this.searchObj, pagination));
      },
      search(prepare, data) {
        if (data !== undefined) this.searchData = data;
        if (prepare) this.prepareChips();
        const searchObj = clearEmptyFields(Object.assign({}, this.searchData));
        if (searchObj.employeeId) {
          searchObj.employeeId = searchObj.employeeId.id;
        }

        this.searchObj = searchObj;
        this.tablePage = 1;
        this.lastPagination = null;
        this.fetchVouchers(this.buildFetchParams(searchObj, null));
      },
      changeSearchData(element) {
        this.searched[element] = null;
        this.searchData[element] = null;
        if (element === 'created') {
          this.searchData.created_at_start = null;
          this.searchData.created_at_due = null;
        }
        if (element === 'expired') {
          this.searchData.expired_at_start = null;
          this.searchData.expired_at_due = null;
        }
        if (element === 'realized') {
          this.searchData.realized_at_start = null;
          this.searchData.realized_at_due = null;
        }

        this.search(false);
      },
      prepareChips() {
        this.searched = Object.assign({}, this.searchData);
        this.searched.created = this.formatDate('created_at_start', 'created_at_due', this.searchData);
        this.searched.expired = this.formatDate('expired_at_start', 'expired_at_due', this.searchData);
        this.searched.realized = this.formatDate('realized_at_start', 'realized_at_due', this.searchData);
      },
      formatDate(createdOrExpiredAtKey, createdOrExpiredDueKey, input) {
        const searchData = Object.assign({}, input);
        if (searchData[createdOrExpiredAtKey] && searchData[createdOrExpiredDueKey]) {
          return `${searchData[createdOrExpiredAtKey].toString()} — ${searchData[createdOrExpiredDueKey].toString()}`;
        }
        if (searchData[createdOrExpiredAtKey]) {
          return searchData[createdOrExpiredAtKey].toString();
        }
        if (searchData[createdOrExpiredDueKey]) {
          return searchData[createdOrExpiredDueKey].toString();
        }
        return null;
      },
      convertTypeToName(typeId) {
        const typeList = this.getVouchersTypeList.filter(type => type.id === typeId);
        return typeList.length > 0 ? typeList[0].name : 'Nieznany typ';
      },
      disableVoucher(formData) {
        this.deactivateVoucher = false;
        this.showTextarea = false;
        this.turnOffVoucher({
          id: this.voucherIdToEdit,
          formData,
        })
          .then(() => {
            this.fetchVouchers(this.buildFetchParams(this.searchObj, this.lastPagination));
          });
      },
    },
  };
</script>
